module.exports = __webpack_public_path__ + "media/application/images/svgs/transfer-7b91e1844451b1bf51de01f6430de371.svg";